import React from 'react';

const NotFound = () => {
     return (
          <div className='container '>
            <div className=''>
            <img className='w-100 img-fluid' src="https://static3.bigstockphoto.com/2/5/2/large1500/252034765.jpg" alt="" />
            </div>
          </div>
     );
};

export default NotFound;